'use client'

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

import { captureAttribution } from '@/lib/analytics/attribution'

/**
 * Reads the campaign parameters off the URL and keeps them for the calls into the Manager.
 *
 * It runs on every navigation rather than only on mount, because a campaign link can land on any
 * page and the visitor may arrive on a client-side route change (a link from an article, say).
 * An untagged page and a repeat of the stored touch leave it alone, so the repeats cost nothing.
 */
export function AttributionCapture() {
  const pathname = usePathname()

  useEffect(() => {
    captureAttribution()
  }, [pathname])

  return null
}
